import React, { useEffect, useState } from 'react'
import { TextHeader, TextInput, Logo, Button, Terms, useNotifications, MembershipFeatures, Banner } from '@wallyhealth/web-core'
import { times } from 'ramda'
import trim from 'validator/lib/trim'
import classes from 'classnames'
import { isValidPhoneNumber } from '../../../validators/phoneValidator'
import { isValidEmail } from '../../../validators/emailValidator'
import styles from './index.module.css'
import intelService from 'services/intelService'
import adsFacade from 'facades/adsFacade'

const PAGE_NAME = 'JoinStartPage2'

const SmartMouthStrip = () => (
  <div className={styles.smart_mouth}>
    <ul className={styles.smart_mouth_list}>
      {times((index) => (
        <li key={`smart-mouth-list-item-${index}`}>
          Be a smart mouth
        </li>
      ), 20)}
    </ul>
  </div>
)

const MainSection = ({ onInfoCaptured, copy }) => {
  const notifications = useNotifications()

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')

  const hasBanner = !!copy.banner

  const sanitize = (value) => {
    return trim(value)
  }

  const isButtonEnabled = () => {
    return sanitize(firstName) && sanitize(lastName) && sanitize(email) && sanitize(phone)
  }

  const recordSubmitClick = async (sanitizedInputs) => {
    const { eventId } = await intelService.recordClick({
      clickName: 'GetStarted',
      viewName: PAGE_NAME,
      identity: sanitizedInputs
    })
    adsFacade.recordAddToCartEvent({
      eventId,
      identity: sanitizedInputs
    })
  }

  const handleSubmit = () => {
    const sanitizedInputs = {
      firstName: sanitize(firstName),
      lastName: sanitize(lastName),
      email: sanitize(email),
      phone: sanitize(phone)
    }

    if (!isValidEmail(sanitizedInputs.email)) {
      notifications.error('Please enter a valid email.')
      return
    }

    if (!isValidPhoneNumber(sanitizedInputs.phone)) {
      notifications.error('Please enter a valid US phone number.')
      return
    }

    recordSubmitClick(sanitizedInputs)

    onInfoCaptured(sanitizedInputs)
  }

  return (
    <div className={classes({
      [styles.main]: true,
      [styles.main_when_banner]: hasBanner
    })}>
      <div className={styles.main_body}>
        <TextHeader
          className={classes({
            [styles.header]: true,
            [styles.header_when_banner]: hasBanner
          })}
          titleClassName={styles.title}
          title="Let's get this started."
        />

        <div className={styles.form}>
          <div className={styles.names}>
            <TextInput
              className={styles.name}
              label="First Name"
              value={firstName}
              onValueChange={setFirstName}
            />

            <TextInput
              className={styles.name}
              label="Last Name"
              value={lastName}
              onValueChange={setLastName}
            />
          </div>

          <TextInput
            className={styles.email}
            label="Email"
            value={email}
            onValueChange={setEmail}
          />

          <TextInput
            label="Phone"
            className={styles.phone}
            onValueChange={setPhone}
            value={phone}
          />

          <Button
            className={styles.button}
            onClick={handleSubmit}
            disabled={!isButtonEnabled()}
            label={copy.cta}
          />
        </div>

        <Terms
          className={styles.terms}
        />
      </div>
    </div>
  )
}

const SupportingSection = () => (
  <div className={styles.supporting}>
    <div className={styles.bullets}>
      <MembershipFeatures />
    </div>
  </div>
)

const JoinStartPage = ({ onInfoCaptured, copy }) => {
  const hasBanner = !!copy.banner

  useEffect(() => {
    intelService.recordView({ viewName: PAGE_NAME })
  }, [])

  return (
    <div className={styles.container}>
      {hasBanner &&
        <Banner
          text={copy.banner}
        />
      }
      <Logo
        className={classes({
          [styles.logo]: true,
          [styles.logo_when_banner]: hasBanner
        })}
      />
      <MainSection
        onInfoCaptured={onInfoCaptured}
        copy={copy}
      />
      <SupportingSection/>
      <SmartMouthStrip />
    </div>
  )
}

export default JoinStartPage
